import React from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

interface IErrorFallbackProps {
  heading?: string;
  message?: string;
  onRetry?: () => void;
  className?: null | string;
  buttonText?: string;
}

const ErrorFallback: React.FC<IErrorFallbackProps> = ({
  message = "Something went wrong. Please try again.",
  onRetry = () => window.location.reload(),
  className,
  heading = "Oops!",
  buttonText = "Retry",
}) => {
  return (
    <div
      className={`flex flex-col justify-center items-center min-h-[60vh] w-full text-center px-4 ${className}`}
    >
      <div className="w-60">
        <h2 className="text-xl font-semibold text-red-600 font-inter mb-2">
          {heading}
        </h2>
        <p className="text-sm text-neutral-600 dark:text-neutral-300 max-w-sm">
          {message}
        </p>
        <ButtonPrimary onClick={onRetry} sizeClass="sm" className="mt-6">
          {buttonText}
        </ButtonPrimary>
      </div>
    </div>
  );
};

export default ErrorFallback;
